import { checkIsPickUp } from "shared/utility/types";
import { CheckTimeString } from "shared/util/time";

function normalizeId(value) {
  if (value === null || value === undefined) return null;
  if (typeof value === "object" && value.id !== null && value.id !== undefined) return String(value.id);
  return String(value);
}

function normalizeDisplayTime(time) {
  const trimmed = time?.trim?.() ?? time;
  return CheckTimeString(trimmed) ? trimmed : null;
}

function resolveRouteType(row) {
  return row?.routeType ?? row?.type;
}

function getPersonelTransferTime(row, userRef) {
  const userId = normalizeId(userRef);
  if (!userId) return null;

  const detail = (row?.usersdetails || []).find((item) => normalizeId(item?.user) === userId);
  return normalizeDisplayTime(detail?.transfertime);
}

function getVehicleTransferTime(row, studentRef) {
  const studentId = normalizeId(studentRef);
  if (!studentId) return null;

  const location = (row?.routelocations || []).find((item) => normalizeId(item?.student) === studentId);
  return normalizeDisplayTime(location?.transfertime);
}

function getFirstPassengerTransferTime(row) {
  if (Array.isArray(row?.users) && row.users.length > 0) {
    return getPersonelTransferTime(row, row.users[0]);
  }
  if (Array.isArray(row?.student) && row.student.length > 0) {
    return getVehicleTransferTime(row, row.student[0]);
  }
  return null;
}

function getLastPassengerTransferTime(row) {
  if (Array.isArray(row?.users) && row.users.length > 0) {
    return getPersonelTransferTime(row, row.users[row.users.length - 1]);
  }
  if (Array.isArray(row?.student) && row.student.length > 0) {
    return getVehicleTransferTime(row, row.student[row.student.length - 1]);
  }
  return null;
}

/**
 * Toplama: ilk yolcu alış saati (kalkış) → müşteri varış saati.
 * Dağıtma: müşteri kalkış saati → son yolcu bırakış saati.
 */
export function getServiceRouteListTimes(row) {
  const isPickup = checkIsPickUp(resolveRouteType(row));
  const anchorTime = normalizeDisplayTime(row?.routeClientArrivalTime);
  const firstPassengerTime = getFirstPassengerTransferTime(row);
  const lastPassengerTime = getLastPassengerTransferTime(row);

  if (isPickup) {
    return { departure: firstPassengerTime, arrival: anchorTime };
  }

  return { departure: anchorTime, arrival: lastPassengerTime };
}

export function getServiceRouteDepartureTime(row) {
  return getServiceRouteListTimes(row).departure;
}

export function getServiceRouteArrivalTime(row) {
  return getServiceRouteListTimes(row).arrival;
}
